import React, { useState, useEffect } from 'react';
import { useIntl, defineMessages } from 'react-intl';
import cx from 'classnames';
import { Container } from 'semantic-ui-react';

import { OSMMap } from 'volto-venue';
import { Icon } from '@plone/volto/components';
import pinSVG from '@package/icons/pin.svg';
import { ProjectCard } from '@package/components';
import { LeafIcon } from '@package/helpers';

const BANDI_COLORS = {
  'Gestione sostenibile delle acque': 'light-blue',
  'Tutelare e valorizzare la biodiversità': 'medium-green',
  'Tutelare la qualità delle acque': 'blue',
  'Connessione ecologica': 'light-green',
  'Capitale naturale': 'dark-green',
};
const OTHER_BANDI_COLOR = 'other';

const messages = defineMessages({
  ente: { id: 'prj_ente', defaultMessage: 'ENTE' },
  scheda_progetto: {
    id: 'prj_detail',
    defaultMessage: 'Scheda progetto',
  },
  other: {
    id: 'prj_legend_other',
    defaultMessage: 'Altro',
  },
  no_map_points: {
    id: 'search-prj-no-map-points',
    defaultMessage: 'Non ci sono punti da mostrare sulla mappa.',
  },
});

const Map = ({ items }) => {
  const intl = useIntl();
  const [markers, setMarkers] = useState([]);

  const getItemColor = (item) => {
    const k = Object.keys(BANDI_COLORS).filter(
      (c) => item.titolo_bando?.indexOf(c) >= 0,
    );

    if (k.length > 0) {
      return BANDI_COLORS[k[0]];
    }
    return OTHER_BANDI_COLOR;
  };
  useEffect(() => {
    let points = items
      ?.filter(
        (item) =>
          item.geolocation &&
          item.geolocation.latitude &&
          item.geolocation.longitude,
      )
      ?.map((item) => {
        const itemColor = getItemColor(item);
        return {
          title: item.title,
          description: item.description ?? null,
          latitude: item.geolocation.latitude,
          longitude: item.geolocation.longitude,
          divIcon: LeafIcon(
            {
              className: 'bandi_color_' + itemColor,
            },
            item,
          ),
          popupContent: (
            <div>
              <ProjectCard {...item} have_description={true} have_cta={true} />
            </div>
          ),

          // onMarkerClick: (e) => {
          //   // se è un luogo ed ha una scadenza il link è nella popup
          //   if (!(item.end && item['@type'] === 'Venue')) {
          //     history.push(item['@id']);
          //   }
          // },
        };
      });

    setMarkers(points);
  }, [items, intl]);

  return (
    <div className="map-wrapper">
      {__CLIENT__ && markers?.length > 0 ? (
        <>
          <OSMMap
            markers={markers}
            showTooltip={true}
            showPopup={true}
            cluster={true}
            mapOptions={{
              scrollWheelZoom: false,
              // tap: false,
              // dragging: false,
            }}
          />

          {/* <div className="legend">
            {Object.keys(BANDI_COLORS).map((k) => (
              <div className="legend-item" key={k}>
                <div className={cx('symbol', 'bandi_color_' + BANDI_COLORS[k])}>
                  <Icon name={pinSVG} size={[20, 28]} />
                </div>
                <div className="label">{k}</div>
              </div>
            ))}
            <div className="legend-item">
              <div className="symbol bandi_color_other">
                <Icon name={pinSVG} size={[20, 28]} />
              </div>
              <div className="label">{intl.formatMessage(messages.other)}</div>
            </div>
          </div> */}
        </>
      ) : __CLIENT__ ? (
        <Container>{intl.formatMessage(messages.no_map_points)}</Container>
      ) : (
        <></>
      )}
    </div>
  );
};

export default Map;
